import { CircleAlert, Inbox, RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FlowMark } from './PageIntro';
import { Button } from './Button';
export function StateDisplay({
  kind = 'loading',
  title,
  description,
  onRetry,
}: {
  kind?: 'loading' | 'empty' | 'error';
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`state-display state-display--${kind}`}
      role={kind === 'error' ? 'alert' : 'status'}
    >
      {kind === 'loading' ? (
        <FlowMark className="flow-mark--loading" />
      ) : (
        <span className="state-display-icon">{kind === 'empty' ? <Inbox /> : <CircleAlert />}</span>
      )}
      <strong>
        {title ??
          t(
            kind === 'loading'
              ? 'common.loading'
              : kind === 'empty'
                ? 'common.emptyState'
                : 'errors.title',
          )}
      </strong>
      {description ? <p>{description}</p> : null}
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry} icon={<RotateCcw size={17} />}>
          {t('common.retry')}
        </Button>
      ) : null}
    </div>
  );
}
